import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Input, RadioGroup, Radio } from 'components/fields'
import { LabeledText } from 'components/misc'
import { FormattedMessage, injectIntl } from 'react-intl'
import { LEVELS } from 'constants/enums'

const PaymentInfoLevel = injectIntl(
  ({
    awards,
    filteredAwardLevels,
    intl,
    isEditing,
    errors,
    participant,
    onPrevLevelChange,
    onSelectBronze,
    values
  }) => {
    if (!isEditing) {
      const prevLevel =
        get(participant, 'previousCompletedAwardLevel.value') ||
        intl.formatMessage({
          id: 'label.no',
          defaultMessage: 'No'
        })

      return (
        <div>
          <LabeledText
            intlKey='label.registering_for_level'
            label='Registering for level'
            value={get(participant, 'awardLevel', '---')}
          />
          <LabeledText
            intlKey='label.any_level_previously'
            label='Any level previously completed'
            value={prevLevel}
          />
          <br />
          <FormattedMessage
            id='note.change_award_lvl_by_al'
            defaultMessage='* Award Level can be changed by Award Leader.'
            intlKey='label.change_award_lvl_by_al'
            tagName='b'
          />
        </div>
      )
    }

    const isBronze = get(values, 'awardLevel.value') === LEVELS.BRONZE.id

    return (
      <div>
        {awards.levels &&
        awards.levels[0] &&
        <RadioGroup
          name='awardLevel.value'
          label='Registering for level:'
          intlKey='label.registering_for_level'
          errors={errors}
          horizontal
        >
          {awards.levels.map(item =>
            <Radio
              label={item.label}
              name='awardLevel.value'
              value={item.value}
              key={item.value}
              onChange={
                item.value === LEVELS.BRONZE.id ? onSelectBronze : null
              }
            />
          )}
        </RadioGroup>}

        <RadioGroup
          label='Any level previously completed'
          intlKey='label.any_level_previously'
          name='helpers.previousCompletedAward.value'
          errors={errors}
          horizontal
        >
          <Radio
            label='Yes'
            intlKey='label.yes'
            name='helpers.previousCompletedAward.value'
            value='yes'
            disabled={isBronze}
          />
          <Radio
            label='No'
            intlKey='label.no'
            name='helpers.previousCompletedAward.value'
            value='no'
            disabled={isBronze}
            onChange={onPrevLevelChange}
          />
        </RadioGroup>
        {get(values, 'helpers.previousCompletedAward.value') === 'yes' &&
        !isBronze &&
        <div>
          {filteredAwardLevels[0] &&
          <RadioGroup
            name='previousCompletedAwardLevel.value'
            label='Level'
            intlKey='label.level'
            errors={errors}
            horizontal
          >
            {filteredAwardLevels.map(item =>
              <Radio
                label={item.label}
                name='previousCompletedAwardLevel.value'
                value={item.value}
                key={item.value}
              />
            )}
          </RadioGroup>}
          <Input
            name='previousCompletedAwardPlace'
            label='Where have you completed?'
            intlKey='label.where_have_you_completed'
          />
        </div>}
      </div>
    )
  }
)

PaymentInfoLevel.propTypes = {
  awards: PropTypes.object,
  filteredAwardLevels: PropTypes.array,
  isEditing: PropTypes.bool,
  errors: PropTypes.object,
  participant: PropTypes.object,
  onPrevLevelChange: PropTypes.func
}

PaymentInfoLevel.displayName = 'PaymentInfoLevel'

export default PaymentInfoLevel
